<template>
  <icon-font
    v-if="show"
    class="invalid-icon"
    type="icon-yishixiao"
    :size="size"
  />
</template>

<script lang="ts" setup>
  defineOptions({
    // 失效盖章，使用时将其父元素设置为position: relative;
    name: 'IsInvalid',
  });
  defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    size: {
      type: [Number, String],
      default: 150,
    },
    top: {
      type: [Number, String],
      default: 0,
    },
    right: {
      type: [Number, String],
      default: 0,
    },
  });
</script>

<style lang="less" scoped>
  .invalid-icon {
    position: absolute;
    top: v-bind(top);
    right: v-bind(right);
    z-index: 9;
  }
</style>
